
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { Building2, Recycle, Truck, Users } from "lucide-react";

const Collectivites = () => {
  const services = [
    {
      title: "Collecte sélective",
      description: "Organisation de la collecte sélective pour votre commune",
      icon: Recycle
    },
    {
      title: "Gestion des déchetteries",
      description: "Exploitation et gestion complète de déchetteries",
      icon: Building2
    },
    {
      title: "Collecte en porte-à-porte",
      description: "Service de collecte à domicile pour les habitants",
      icon: Truck
    },
    {
      title: "Sensibilisation",
      description: "Campagnes de sensibilisation au tri et recyclage",
      icon: Users
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Services Collectivités - Groupe Fabre Environnement"
        description="Solutions de gestion des déchets pour collectivités : collecte sélective, déchetteries, sensibilisation. Partenaire des communes."
        canonical="/services/collectivites"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Services Collectivités</h1>
              <p className="text-xl opacity-90">
                Partenaire des communes et collectivités pour une gestion 
                responsable et efficace des déchets.
              </p>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((service, index) => {
                const IconComponent = service.icon;
                return (
                  <div key={index} className="bg-gray-50 p-8 rounded-lg">
                    <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-fabre-gray mb-4">{service.title}</h3>
                    <p className="text-gray-600">{service.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-blue-50">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-fabre-gray mb-6">
              Développons ensemble votre projet
            </h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Contactez-nous pour discuter de vos besoins et élaborer 
              une solution sur mesure pour votre collectivité.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md font-medium transition-colors"
            >
              Nous contacter
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Collectivites;
